// extracted by mini-css-extract-plugin
export var productImage = "_zo-0";